export default __webpack_public_path__ + "static/media/remove.791f09db.svg";